import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import jsPDF from "jspdf";
import "jspdf-autotable";
import CalendarIcon from "../img/calendaricon.svg";
import { instance2 } from "../utils/axiosInstance"; // adjust your axios import if needed
import { registerLocale } from "react-datepicker";
import id from "date-fns/locale/id"; // Indonesian locale
import { basecode } from "../mainscreen/pesananscreen/baserobotocode";
import BgnIcon from "../img/logobgn250.png";
import { formatNumber } from "../numberingformat"; // Adjust the import
import { ReactComponent as BackButton } from "../img/bacbuttonicon.svg";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../shadcn/select";
import { Button } from "../shadcn/button";
import downloadWeeklyPDF from "./weeklyreportpdf";
import downloadWeeklyExcel from "./weeklyreportexcel";
import {downloadMenuPDF} from "./weeklymenupdf";
import { localDateString } from "src/lib/utils";

registerLocale("id", id);

export default function WeeklyReport2() {
  const roleId = parseInt(localStorage.getItem("roleId"), 10);
  const locationId = parseInt(localStorage.getItem("locationId"), 10);
  const kitchenId = parseInt(localStorage.getItem("kitchenId"), 10);
  const navigate = useNavigate();
  const location = useLocation();

  const [selectedDate, setSelectedDate] = useState(new Date());
  const [isOpen, setIsOpen] = useState(false);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  //const startIndex = (currentPage - 1) * itemsPerPage;
  const totalPages = Math.ceil(data.length / itemsPerPage);
  const paginatedData = data.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage,
  );
const [startDate, setStartDate] = useState(new Date());   // default: today
const [endDate, setEndDate] = useState(new Date());       // default: today
  const handlePreviousPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  // Determine which page numbers to show
  let pageNumbers = [];
  const maxVisiblePages = 5;

  if (totalPages <= maxVisiblePages) {
    pageNumbers = Array.from({ length: totalPages }, (_, i) => i + 1);
  } else {
    if (currentPage <= 3) {
      // Near the beginning
      pageNumbers = [1, 2, 3, 4, 5, "...", totalPages];
    } else if (currentPage >= totalPages - 2) {
      // Near the end
      pageNumbers = [
        1,
        "...",
        totalPages - 4,
        totalPages - 3,
        totalPages - 2,
        totalPages - 1,
        totalPages,
      ];
    } else {
      // In the middle
      pageNumbers = [
        1,
        "...",
        currentPage - 1,
        currentPage,
        currentPage + 1,
        "...",
        totalPages,
      ];
    }
  }
  // Find Monday and Sunday for the selected week
  const getWeekRange = (date) => {
    const current = new Date(date);
    const day = current.getDay(); // Sunday = 0
    const diffToMonday = day === 0 ? -6 : 1 - day;
    const monday = new Date(current);
    monday.setDate(current.getDate() + diffToMonday);
    const sunday = new Date(monday);
    sunday.setDate(monday.getDate() + 6);
    return { monday, sunday };
  };

  const { monday, sunday } = getWeekRange(selectedDate);
const CustomInput = React.forwardRef(
  ({ startDate, endDate, onClick, isOpen }, ref) => (
    <button
      className="flex items-center justify-between w-full px-4 py-3 border rounded-full bg-white text-xxs md:text-xxs lg:text-base"
      onClick={onClick}
      ref={ref}
      type="button"
    >
      <div className="flex items-center gap-2">
        <img src={CalendarIcon} alt="Calendar" className="h-5 w-5" />
        <div className="w-px h-5 bg-gray-300 mx-1"></div>
        <span>
          {startDate
            ? startDate.toLocaleDateString("id-ID", {
                day: "2-digit",
                month: "long",
                year: "numeric",
              })
            : "Pilih tanggal"}
          {" - "}
          {endDate
            ? endDate.toLocaleDateString("id-ID", {
                day: "2-digit",
                month: "long",
                year: "numeric",
              })
            : "Pilih tanggal"}
        </span>
      </div>
<span
  aria-hidden="true"
  className={`ml-2 h-5 w-5 transition-transform mr-4 ${isOpen ? "rotate-180" : ""}`}
  style={{
    WebkitMask: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"><path d="M5 7l5 5 5-5"/></svg>') center / contain no-repeat`,
    mask: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"><path d="M5 7l5 5 5-5"/></svg>') center / contain no-repeat`,
    backgroundColor: "rgb(107 114 128)" // gray-500
  }}
/>

    </button>
  )
);


useEffect(() => {
  const fetchData = async () => {
    try {
      if (!startDate || !endDate) return;    // wait until both picked
      setLoading(true);

      const start = new Date(startDate);
      start.setHours(0,0,0,0);
      const end = new Date(endDate);
      end.setHours(0,0,0,0);

      const startStr = localDateString(start);
      const endStr   = localDateString(end);

      const response = await instance2.get(
        `report_dates/${kitchenId}/${startStr}/${endStr}`
      );

      setData(
        (response.data ?? []).sort(
          (a, b) => new Date(a.date) - new Date(b.date)
        )
      );
    } catch (error) {
      console.error("Error fetching production data:", error);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  fetchData();
}, [startDate, endDate, locationId, kitchenId]);


  const downloadPDF = async () => {
    if (data.length === 0) {
      alert("Tidak ada data untuk diunduh.");
      return;
    }
    const doc = new jsPDF();
    const locationName = localStorage.getItem("locationname") || "Lokasi";
    const kitchenName = localStorage.getItem("kitchenname") || "Dapur";

    // Embed Roboto font
    doc.addFileToVFS("Roboto-Regular.ttf", basecode);
    doc.addFont("Roboto-Regular.ttf", "Roboto", "normal");
    doc.addFont("Roboto-Regular.ttf", "Roboto", "bold");
    doc.setFont("Roboto", "normal");

    // Load icon as base64
    const loadImageAsBase64 = (imgSrc) =>
      new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = "Anonymous";
        img.src = imgSrc;
        img.onload = () => {
          const canvas = document.createElement("canvas");
          canvas.width = img.width;
          canvas.height = img.height;
          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0);
          resolve(canvas.toDataURL("image/png"));
        };
        img.onerror = (err) => reject(err);
      });

    const iconBase64 = await loadImageAsBase64(BgnIcon);
    const pageWidth = doc.internal.pageSize.width;
    const pageHeight = doc.internal.pageSize.height;

    // Header function
    const addHeader = (doc, pageWidth) => {
      const textYOffset = 10;

      // Icon on the LEFT
      const iconWidth = 23;
      const iconHeight = 23;
      const iconX = 14;
      const iconY = textYOffset + 2;
      doc.addImage(iconBase64, "PNG", iconX, iconY, iconWidth, iconHeight);

      doc.setFontSize(12);
      doc.setFont("Roboto", "bold");
      doc.setTextColor(59, 78, 135);
      doc.text("LAPORAN PRODUKSI MINGGUAN", 14, textYOffset + 19 + iconHeight, {
        align: "left",
      });
      doc.setTextColor(0, 0, 0);

      const alamatLines = [
        "Kompleks Kementerian Pertanian",
        "Jl Harsono RM No.3 Gedung E",
        "Ragunan, Ps. Minggu, Kota Jakarta Selatan, Daerah Khusus Ibukota Jakarta 12550",
      ];
      const linkBgn = "https://www.bgn.go.id/";
      const textWidthLinkBgn = doc.getTextWidth(linkBgn);

      const startX = 40;
      let startY = textYOffset + iconHeight / 2 - 4;

      alamatLines.forEach((line) => {
        doc.setFontSize(8);
        doc.text(line, startX, startY);
        startY += 4;
      });

      doc.setTextColor(0, 120, 255);
      doc.textWithLink(linkBgn, startX, startY, { url: linkBgn });
      doc.setDrawColor(0, 120, 255);
      doc.line(startX, startY + 1, startX + textWidthLinkBgn - 14, startY + 1);
      doc.setTextColor(0, 0, 0);
      doc.setDrawColor(0, 0, 0);

      // Info section
      const margin = 14;
      const rowHeight = 8;
      const colWidth = (pageWidth - margin * 3) / 2; // Two columns
      const startYInfo = 60;

      // Koperasi column
      doc.setFillColor(59, 78, 135);
      doc.rect(margin, startYInfo, colWidth, rowHeight, "F");
      doc.setFontSize(10);
      doc.setTextColor(255, 255, 255);
      doc.setFont("Roboto", "bold");
      doc.text("DAPUR", margin + 2, startYInfo + 5.5);
      doc.setTextColor(0, 0, 0);
      doc.setFont("Roboto", "normal");
      doc.setFontSize(10);
      doc.text(kitchenName, margin + 2, startYInfo + rowHeight + 6);

      // Periode column
      const secondColX = margin + colWidth + 14;
      doc.setFillColor(59, 78, 135);
      doc.rect(secondColX, startYInfo, colWidth, rowHeight, "F");
      doc.setFontSize(10);
      doc.setTextColor(255, 255, 255);
      doc.setFont("Roboto", "bold");
      doc.text("PERIODE", secondColX + 2, startYInfo + 5.5);
      doc.setTextColor(0, 0, 0);
      doc.setFont("Roboto", "normal");
      doc.setFontSize(10);
      const dateValue = `${monday.toLocaleDateString("id-ID", {
        day: "2-digit",
        month: "long",
        year: "numeric",
      })} - ${sunday.toLocaleDateString("id-ID", {
        day: "2-digit",
        month: "long",
        year: "numeric",
      })}`;
      doc.text(dateValue, secondColX + 2, startYInfo + rowHeight + 6);

      return startYInfo + rowHeight + 18;
    };

    let yOffset = addHeader(doc, pageWidth);

    const tableHead = [
      [
        {
          content: "No",
          rowSpan: 2,
          styles: { valign: "middle", halign: "center" },
        },
        {
          content: "Tanggal",
          rowSpan: 2,
          styles: { valign: "middle", halign: "center" },
        },
        {
          content: "Rencana",
          rowSpan: 2,
          styles: { valign: "middle", halign: "right" },
        },
        {
          content: "Pengiriman",
          rowSpan: 2,
          styles: { valign: "middle", halign: "right" },
        },
        {
          content: "Diterima",
          rowSpan: 2,
          styles: { valign: "middle", halign: "right" },
        },
        { content: "Rating", colSpan: 2, styles: { halign: "center" } },
      ],
      [
        { content: "Kuantitas", styles: { halign: "center" } },
        { content: "Kualitas", styles: { halign: "center" } },
      ],
    ];

    if (roleId === 4) {
      tableHead[0].splice(1, 0, {
        content: "Dapur",
        rowSpan: 2,
        styles: { valign: "middle", halign: "center" },
      });
    }

    const tableData = data.map((item, index) => {
      const row = [
        index + 1,
        new Date(item.date).toLocaleDateString("id-ID"),
        formatNumber(item.qty_sch) ?? "-",
        formatNumber(item.qty_real) ?? "-",
        formatNumber(item.qty_received) ?? "-",
        item.rate_qty ?? "-",
        item.rate_quality ?? "-",
      ];
      if (roleId === 4) {
        row.splice(1, 0, item.kitchen_name ?? "-");
      }
      return row;
    });

    const columnStyles = {
      0: { halign: "center" }, // No
    };
    if (roleId === 4) {
      columnStyles[1] = { halign: "left" }; // Dapur
      columnStyles[2] = { halign: "center" }; // Tanggal
      columnStyles[3] = { halign: "right" }; // Rencana
      columnStyles[4] = { halign: "right" }; // Pengiriman
      columnStyles[5] = { halign: "right" }; // Diterima
      columnStyles[6] = { halign: "center" }; // Kuantitas
      columnStyles[7] = { halign: "center" }; // Kualitas
    } else {
      columnStyles[1] = { halign: "center" }; // Tanggal
      columnStyles[2] = { halign: "right" }; // Rencana
      columnStyles[3] = { halign: "right" }; // Pengiriman
      columnStyles[4] = { halign: "right" }; // Diterima
      columnStyles[5] = { halign: "center" }; // Kuantitas
      columnStyles[6] = { halign: "center" }; // Kualitas
    }

    doc.autoTable({
      theme: "grid",
      head: tableHead,
      body: tableData,
      startY: yOffset,
      styles: {
        fontSize: 8,
        font: "Roboto",
        lineColor: [0, 0, 0],
        lineWidth: 0.2,
      },
      headStyles: {
        fillColor: [59, 78, 135],
        textColor: [255, 255, 255],
        fontStyle: "bold",
      },
      columnStyles: columnStyles,
    });

    yOffset = doc.lastAutoTable.finalY + 30;

    // Signature Block
    const signatureX1 = 15;

    doc.setFontSize(10);
    doc.setFont("Roboto", "normal");
    doc.setTextColor(0, 0, 0);

    doc.text("Kepala SPPG", signatureX1, yOffset);
    doc.line(signatureX1, yOffset + 25, signatureX1 + 60, yOffset + 25);
    // doc.text("Nama:", signatureX1, yOffset + 35);
    // doc.text("Jabatan:", signatureX1, yOffset + 42);
    // doc.text("Jam Terima:", signatureX1, yOffset + 49);

    const addFooter = (doc) => {
      const pageCount = doc.internal.getNumberOfPages();
      for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        const footerText = `Halaman ${i} dari ${pageCount}`;
        doc.setFontSize(7);
        doc.text(
          footerText,
          pageWidth - doc.getTextWidth(footerText) - 10,
          pageHeight - 10,
        );
      }
    };

    addFooter(doc);

    doc.save(
      `laporan-produksi-mingguan-${monday.toISOString().split("T")[0]}.pdf`,
    );
  };

  return (
    <div className="p-4">
      {/* Header */}
      <div className="flex flex-row items-center gap-4 mb-4">
        <div
          className="bg-white p-2 rounded-full cursor-pointer"
          onClick={() => navigate("/tabeljadwalcustomer")}
        >
          <BackButton className="rotate-180 text-black" />
        </div>
        <h2 className="text-2xl font-medium">Laporan Periodik</h2>
      </div>

      {/* Date Picker */}
      <div className="flex items-center justify-between gap-8 mb-4">
        <div className="flex items-center gap-4">
          <label className="text-gray-700 font-medium text-xxs md:text-xxs lg:text-base">
            Pilih Tanggal:
          </label>
          <DatePicker
  selectsRange
  startDate={startDate}
  endDate={endDate}
  onChange={(dates) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
    // Optional: reset to first page when the range changes
    if (start || end) setCurrentPage(1);
  }}
  //isClearable
  dateFormat="yyyy-MM-dd"
  customInput={<CustomInput startDate={startDate} endDate={endDate} isOpen={isOpen} />}
  onCalendarOpen={() => setIsOpen(true)}
  onCalendarClose={() => setIsOpen(false)}
  // Keep blocking Sat/Sun if desired:
  filterDate={(date) => date.getDay() !== 0 && date.getDay() !== 6}
/>

        </div>
        <div className="flex flex-row md:flex-row gap-2">
         <Button
  className="bg-oren-no hover:bg-oren-hover"
  onClick={() => {
    if (!startDate || !endDate) return;
    downloadMenuPDF(startDate, endDate, data);
  }}
  disabled={data.length === 0 || !startDate || !endDate}
>
  Download Menu Sebagai PDF
</Button>
         <Button
  className="bg-oren-no hover:bg-oren-hover"
  onClick={() => {
    if (!startDate || !endDate) return;
    downloadWeeklyPDF(data, startDate, endDate);
  }}
  disabled={data.length === 0 || !startDate || !endDate}
>
  Download Sebagai PDF
</Button>
         <Button
  className="bg-oren-no hover:bg-oren-hover"
  onClick={() => {
    if (!startDate || !endDate) return;
    downloadWeeklyExcel(data);
  }}
  disabled={data.length === 0 || !startDate || !endDate}
>
  Download Sebagai Excel
</Button>



          {/* {[3, 4, 5].includes(roleId) && (
            <Select
              onValueChange={(value) => navigate(value)}
              value={location.pathname}
            >
              <SelectTrigger>
                <SelectValue placeholder="Pilih Laporan" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="/dailyreport">Laporan Harian</SelectItem>
                <SelectItem value="/weeklyreport">Laporan Mingguan</SelectItem>
                <SelectItem value="/monthlyreport">Laporan Bulanan</SelectItem>
              </SelectContent>
            </Select>
          )} */}
        </div>
      </div>

      {/* Table */}
      <div className="overflow-x-auto rounded-lg">
        {loading ? (
          <p>Loading...</p>
        ) : (
          <div className="hidden md:block">
            <table className="min-w-full text-sm table-fixed">
              <thead>
                <tr className="border-b bg-white font-semibold text-gray-700">
                  <th
                    rowSpan="2"
                    className="px-4 py-2 text-center align-middle"
                  >
                    No
                  </th>
                    <th
                      rowSpan="2"
                      className="px-4 py-2 text-left align-middle"
                    >
                      Nama
                    </th>
                  <th rowSpan="2" className="px-4 py-2 text-left align-middle">
                    Tanggal
                  </th>
                  <th colSpan="2" className="px-4 py-2 text-center">
                    Jumlah Proposal
                  </th>
                  <th colSpan="2" className="px-4 py-2 text-center">
                    Jumlah Realisasi
                  </th>
                </tr>
                <tr className="border-b bg-white font-semibold text-gray-700">
                  <th className="px-4 py-2 text-center">
                      {`Siswa Kelas`} <br /> {`1 - 3`}
                  </th>
                  <th className="px-4 py-2 text-center">
                      {`Siswa Kelas`} <br /> {`4 - 6`}
                  </th>
                  <th className="px-4 py-2 text-center">
                      {`Siswa Kelas`} <br /> {`1 - 3`}
                  </th>
                  <th className="px-4 py-2 text-center">
                      {`Siswa Kelas`} <br /> {`4 - 6`}
                  </th>
                </tr>
              </thead>
              <tbody>
                {paginatedData.length > 0 ? (
                  paginatedData.map((item, index) => (
                    <tr
                      key={item.id}
                      className={`${index % 2 === 0 ? "bg-transparent" : "bg-white"} border-b`}
                    >
                      <td className="px-4 py-2 text-center">
                        {index + 1}
                      </td>
                        <td className="px-4 py-2 text-left">
                          {item.customer_name || "-"}
                        </td>
                      <td className="px-4 py-2 text-left">
                        {item.date
                          ? new Date(item.date).toLocaleDateString("id-ID", {
                              year: "numeric",
                              month: "long",
                              day: "2-digit",
                            })
                          : "-"}
                      </td>
                      <td className="px-4 py-2 text-right w-1/12">
                        {item.kelas_13_sch != null
                          ? formatNumber(item.kelas_13_sch)
                          : "-"}
                      </td>
                      <td className="px-4 py-2 text-right w-1/12">
                        {item.kelas_46_sch != null
                          ? formatNumber(item.kelas_46_sch)
                          : "-"}
                      </td>
                      <td className="px-4 py-2 text-right w-1/12">
                        {item.kelas_13_real != null
                          ? formatNumber(item.kelas_13_real)
                          : "-"}
                      </td>
                      <td className="px-4 py-2 text-right w-1/12">
                        {item.kelas_46_real != null
                          ? formatNumber(item.kelas_46_real)
                          : "-"}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="8" className="text-center py-4 text-gray-500">
                      Tidak ada data.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}

        {loading ? (
          <p>Loading...</p>
        ) : (
          <div className="md:hidden space-y-4">
            {paginatedData.length > 0 ? (
              paginatedData.map((item, index) => (
                <div
                  key={item.id}
                  className="border rounded-xl p-4 shadow-sm bg-white"
                >
                  <p className="text-sm font-semibold mb-2">
                    {index + 1}. {item.kitchen_name}
                  </p>
                  <p className="text-xs text-gray-600 mb-1">
                    Tanggal:{" "}
                    {new Date(item.date).toLocaleDateString("id-ID", {
                      year: "numeric",
                      month: "long",
                      day: "2-digit",
                    })}
                  </p>
                  <div className="text-xs space-y-1">
                    <p>
                      Jumlah Proposal:{" "}
                      <span className="float-right">{item.qty_sch ?? "-"}</span>
                    </p>
                    <p>
                      Jumlah Pengiriman:{" "}
                      <span className="float-right">
                        {item.qty_real ?? "-"}
                      </span>
                    </p>
                    <p>
                      Jumlah Diterima:{" "}
                      <span className="float-right">
                        {item.qty_received ?? "-"}
                      </span>
                    </p>
                    <p>
                      Rating Kuantitas:{" "}
                      <span className="float-right">
                        {item.rate_qty ?? "-"}
                      </span>
                    </p>
                    <p>
                      Rating Kualitas:{" "}
                      <span className="float-right">
                        {item.rate_quality ?? "-"}
                      </span>
                    </p>
                  </div>
                </div>
              ))
            ) : (
              <p className="text-center text-sm text-gray-600">
                Tidak ada data.
              </p>
            )}
          </div>
        )}

        {/* Pagination Controls */}
        <div className="flex justify-center items-center mt-4 text-xs sm:text-sm">
          {/* Previous Button */}
          <button
            className={`px-2 py-2 rounded ${
              currentPage === 1
                ? "text-gray-400 cursor-not-allowed"
                : "text-gray-500 hover:text-black"
            }`}
            onClick={handlePreviousPage}
            disabled={currentPage === 1}
          >
            <span className="font-bold text-lg sm:text-2xl">{"<"}</span>
          </button>

          {/* Page Numbers */}
          <div className="flex items-center">
            {pageNumbers.map((page, index) => (
              <span
                key={index}
                onClick={() => typeof page === "number" && setCurrentPage(page)}
                className={`mx-1 px-2 sm:px-3 py-1 cursor-pointer rounded-full ${
                  currentPage === page
                    ? "text-black font-semibold"
                    : "text-gray-700"
                } ${page === "..." ? "cursor-default text-gray-400" : ""}`}
              >
                {page}
              </span>
            ))}
          </div>

          {/* Next Button */}
          <button
            className={`px-2 py-2 rounded ${
              currentPage === totalPages
                ? "text-gray-400 cursor-not-allowed"
                : "text-gray-500 hover:text-black"
            }`}
            onClick={handleNextPage}
            disabled={currentPage === totalPages}
          >
            <span className="font-bold text-lg sm:text-2xl">{">"}</span>
          </button>
        </div>
      </div>
    </div>
  );
}
